import { css as emotionCSS } from '@emotion/react';
import {
  Dialog as MuiDialog,
  DialogProps as MuiDialogProps,
  Paper,
  paperClasses,
  Popper,
  PopperProps,
  Theme,
} from '@mildang/mui';
import { ReactNode } from 'react';

const rootStyle = ({
  disableWidthSetting = false,
  theme,
  width,
  height,
}: {
  theme: Theme;
  width?: number;
  height?: number;
  disableWidthSetting?: boolean;
}) => emotionCSS`
  ${
    !disableWidthSetting &&
    emotionCSS`
    & .${paperClasses.root} {
      width: ${width}px;
      max-width: ${width}px;
      min-height: ${height}px;
    }
  `
  }
`;

export type DialogType = 'popper' | 'normal';

export interface PopperDialogProps extends PopperProps {
  type?: 'popper';
  width?: number;
  height?: number;
}

export interface NormalDialogProps extends MuiDialogProps {
  type?: 'normal';
  width?: number;
  height?: number;
}

export type DialogProps = (PopperDialogProps | NormalDialogProps) & {
  children?: ReactNode;
  disableWidthSetting?: boolean;
};

const Dialog = (props: DialogProps) => {
  const {
    disableWidthSetting = false,
    children,
    type = 'normal',
    width = 312,
    height = 224,
    ...others
  } = props;

  if (props.type === 'popper') {
    return (
      // @ts-ignore
      <Popper {...others}>
        <Paper elevation={6}>{children}</Paper>
      </Popper>
    );
  }

  return (
    <MuiDialog css={(theme: Theme) => rootStyle({ theme, width, height, disableWidthSetting })} {...others}>
      {children}
    </MuiDialog>
  );
};

export default Dialog;
